import type {
  DrawConstraints,
  EmailMarketingConstraint,
  MaxWinnersPerStore,
} from '@lotta/shared/types-lottery-schemas';

export const isMaxWinnersPerStoreConstraint = (
  constraint: DrawConstraints
): constraint is MaxWinnersPerStore => {
  return 'storeIds' in constraint;
};

export const isEmailMarketingConstraint = (
  constraint: DrawConstraints
): constraint is EmailMarketingConstraint => {
  return 'emailMarketingRequired' in constraint;
};
